import { takeEvery } from 'redux-saga/effects';

import * as resetPasswordActins from '../../store/modules/auth/resetPassword';
import { resetPassword } from './utils';

export default function* listenResetPassword() {
  yield takeEvery(resetPasswordActins.resetPassword.toString(), resetPassword);
}
